import { HeartbeatData } from './data';
import { SocketIncomingMessage } from './socket';

export const isHeartbeatMessage = (event: SocketIncomingMessage): event is HeartbeatData =>
  (event as HeartbeatData).heartbeat !== undefined;
